import { getAllMessages, setMessageAsRead, getAllMessagesV2 } from '@/api/notification'
export default {
    state: {
        messages: [],

    },

    mutations: {

        SET_ITEMS: (state, data) => {
            state.messages = [...data]
        },
        READ_ITEM: (state, index) => {
            state.messages[index].readDate = 1;
        },

    },

    actions: {
        getAllMessages({ commit }) {
            return new Promise((resolve, reject) => {
                getAllMessages().then(response => {
                    if (!response.data) {
                        reject('error')
                    }
                    const data = response.data;
                    commit('SET_ITEMS', data)
                    resolve(response)

                }).catch(error => {
                    reject(error)
                })
            })
        },
        getAllMessagesV2({ commit }, payload) {

            return new Promise((resolve, reject) => {
                commit("SET_API_RUNNING", true);
                commit('SET_ITEMS', [])
                getAllMessagesV2(payload).then(response => {
                    if (!response.data) {
                        reject('error')
                    }
                    const data = response.data;
                    if (data.Success !== false) {
                        commit('SET_ITEMS', data)
                    }
                    commit("SET_API_RUNNING", false);

                    resolve(response)

                }).catch(error => {
                    reject(error)
                })
            })
        },
        setMessageAsRead({ commit }, payload) {
            //return;
            return new Promise((resolve, reject) => {
                setMessageAsRead(payload.id).then(response => {
                    if (!response.data) {
                        reject('error')
                    }
                    const data = response.data;
                    commit('READ_ITEM', payload.index)
                    resolve(response)

                }).catch(error => {
                    reject(error)
                })
            })
        },

    }
}